var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00195 1.39289C2.99475 0.615515 3.62109 -0.0047711 4.40746 2.76564e-05L13.3369 0.18507L13.3467 0.185159C14.147 0.192395 14.806 0.843554 14.8134 1.63414L15 10.4646C15.0048 11.2414 14.377 11.8602 13.5901 11.8531C12.7897 11.8459 12.1307 11.1947 12.1233 10.4042L12.1232 10.3917L11.9112 5.09082L2.47007 14.4178C1.92663 14.9547 1.01604 14.9618 0.436024 14.3888C-0.143974 13.8158 -0.136798 12.9162 0.406621 12.3794L9.84742 3.0527L4.48141 2.84198L4.46867 2.84187C3.66834 2.83463 3.00927 2.18348 3.00195 1.39289Z",
    fill: "#009C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowGreen);
export default __webpack_public_path__ + "static/media/up-arrow-green.78e9851e340a77235209482d6a61da96.svg";
export { ForwardRef as ReactComponent };